import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative py-16 md:py-24 bg-background-100 overflow-hidden">
      {/* 顶部过渡带 */}
      <div className="absolute top-0 left-0 right-0 h-20 bg-gradient-to-b from-background-50 to-transparent pointer-events-none" />
      {/* 装饰光晕 */}
      <div className="absolute top-1/2 -left-40 w-[500px] h-[500px] rounded-full bg-primary-100/15 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-accent-100/20 blur-[100px] pointer-events-none" />

      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div>
            <span className="text-xs font-medium text-foreground-400 uppercase tracking-widest">Browse by Category</span>
            <h2 className="mt-2 text-3xl md:text-5xl font-heading font-bold text-foreground-900">
              Shop the Look<br />
              <span className="italic font-normal text-foreground-600">Your Way</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-xs">
            All categories link directly to verified pandabuyspreadsheet collections on our main platform.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-50 hover:ring-2 hover:ring-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-40 md:h-48 w-full overflow-hidden bg-background-200">
                <img
                  src={cat.image}
                  alt={`${cat.name} pandabuy spreadsheet category`}
                  title={`${cat.name} pandabuy finds`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 whitespace-nowrap">{cat.name}</h3>
                <span className="text-xs text-primary-500 mt-1 inline-block group-hover:underline">Browse &rarr;</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}